export default __webpack_public_path__ + "static/media/search-blue.2e620514.svg";